import drushim_lodash from 'lodash';
import SmileyOptions from '../lib/enums/SmileyOptions';

export const getters = {

  /**
   * Returns a user IsEmailVerified status
   *
   */
  displayOtp: state => {
    if (state.auth.loggedIn) {
      if (state.auth.user.UserProfile?.Profile.Email &&
        !state.auth.user.UserProfile?.Profile.IsEmailVerified) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }

  },

  isLogged: state => {
    if (state.auth.user != null) {
      return state.auth.user.IsError === false;
    }

    return false;
  },

  CurrentUser: (state, getters) => {
    if (getters.isLogged) {
      return state.auth.user.UserProfile;
    } else {
      return undefined;
    }
  },
  NumberOfAgents: (state, getters) => {
    if (getters.isLogged) {
      return state.auth.user.UserProfile.SmartAgents;
    } else {
      return undefined;
    }
  },
  ActiveAgents: (state, getters) => {
    if (getters.isLogged) {
      return drushim_lodash.filter(state.auth.user.UserProfile.SmartAgents, function (o) {
        return o.Active && !o.IsDelete;
      });
    } else {
      return undefined;
    }
  },

  SmartAgentActive: (state, getters) => {
    if (getters.isLogged) {
      return state.auth.user.UserProfile.SmartAgentActive;
    } else {
      return undefined;
    }
  },

  checkIfAppliedForJob: (state, getters) => code => {
    if (getters.isLogged) {
      return drushim_lodash.has(state.auth.user.UserProfile.JobHistory, code);
    } else {
      return false;
    }
  },

  sendCvDate: (state, getters) => code => {
    if (!drushim_lodash.isNil(state.auth.user) && getters.isLogged) {
      if (drushim_lodash.has(state.auth.user.UserProfile.JobHistory, code)) {
        return state.auth.user.UserProfile.JobHistory[code].SentDate;
      } else {
        return new Date().toISOString().slice(0, 10);
      }
    }
  },

  JobBasket: (state, getters) => {
    if (getters.isLogged) {
      return state.auth.user.UserProfile.JobBasket.concat(
        state.auth.user.UserProfile.NotDecidedJobBasket
      );
    } else {
      return [];
    }
  },

  NoJobBasket: (state, getters) => {
    if (getters.isLogged) {
      return state.auth.user.UserProfile.NoJobBasket;
    } else {
      return [];
    }
  },

  checkIfJobIsLiked: (state, getters) => code => {
    if (getters.isLogged) {
      return getters.JobBasket.includes(code);
    } else {
      return state.authUser.jobsBasket.has(code);
    }
  },

  JobHistory: (state, getters) => {
    if (getters.isLogged) {
      return state.auth.user.UserProfile.JobHistory;
    } else {
      return [];
    }
  },

  JobRank: (state, getters) => code => {
    if (getters.isLogged) {
      if (state.auth.user.UserProfile.NotDecidedJobBasket.includes(code)) {
        return SmileyOptions.HaventDecided;
      } else if (state.auth.user.UserProfile.JobBasket.includes(code)) {
        {
          return SmileyOptions.Like;
        }
      } else if (state.auth.user.UserProfile.NoJobBasket.includes(code)) {
        {
          return SmileyOptions.DisLike;
        }
      }
    } else {
      return SmileyOptions.None;
    }
  },
  ShowSmartAgentGuidAgentsPage: (state, getters) => {
    if (getters.isLogged) {
      return state.auth.user.UserProfile.ShowSmartAgentGuidAgentsPage;
    } else {
      return false;
    }
  },

  ShowSmartAgentGuidMyBoard: (state, getters) => {
    if (getters.isLogged) {
      return state.auth.user.UserProfile.ShowSmartAgentGuidMyBoard;
    } else {
      return false;
    }
  },
};
